<template>
  <b-skeleton-wrapper :loading="!loaded">
    <template #loading>
      <b-col md="12">
        <b-skeleton width="100%" height="200px"></b-skeleton>
      </b-col>
    </template>
    <div class="mc-dashboard__widget-summarytrip-item d-flex flex-column justify-content-between">
      <h5 class="mc-dashboard__widget-title">
        <div class="d-flex flex-row justify-content-between">
          <div style="text-wrap: wrap">
            {{ title }}
          </div>
          <div>
            <i class="mc-fa icon-outline_info" :id="title.replace(' ', '-')"></i>
            <b-tooltip :target="title.replace(' ', '-')" triggers="hover" placement="topleft">
              {{ tooltip }}
            </b-tooltip>
          </div>
        </div>
      </h5>
      <b-row>
        <b-col v-for="value in datas" :md="12 / datas.length">
          <h2>{{ thousandFormat(value.value) }}</h2>
          <p>{{ value.unit }}</p>
        </b-col>
      </b-row>
      <span v-if="totalVehicle !== null"
        >{{ $t('global.object.of') }} {{ thousandFormat(totalVehicle) }}
        {{ $t('global.object.fleet') }}</span
      >
      <span v-if="additionalText !== null">{{ additionalText }}</span>
      <McBadge
        :text="
          lang === 'en'
            ? `${percentage}% ${
                isIncreased
                  ? textPos
                    ? textPos
                    : this.$t('maintenance.lots')
                  : textNeg
                  ? textNeg
                  : $t('maintenance.little')
              }` + ` ${$t('maintenance.fromLastMonth')}`
            : `${
                isIncreased
                  ? textPos
                    ? textPos
                    : this.$t('maintenance.lots')
                  : textNeg
                  ? textNeg
                  : $t('maintenance.little')
              } ${percentage}%` + ` ${$t('maintenance.fromLastMonth')}`
        "
        :variant="isIncreased ? 'outlineSuccess' : 'outlineDanger'"
        size="medium"
        type="button"
      ></McBadge>
    </div>
  </b-skeleton-wrapper>
</template>

<script>
import McBadge from '@/components/McBadge'
import { Helper } from '@/mixin/helper'
import i18n from '../../../../../i18n'

export default {
  components: {
    McBadge,
  },
  mixins: [Helper],
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    tooltip: {
      type: String,
      default: '',
      required: true,
    },
    datas: {
      type: Array,
      default: () => [],
      required: true,
    },
    totalVehicle: {
      type: Number,
      default: null,
    },
    additionalText: {
      type: String,
      default: null,
    },
    percentage: {
      type: Number,
      default: 0,
      required: true,
    },
    isIncreased: {
      type: Boolean,
      default: false,
      required: true,
    },
    loaded: {
      type: Boolean,
      default: false,
    },
    textPos: {
      type: String,
      required: false,
    },
    textNeg: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      lang: i18n.locale,
    }
  },
}
</script>
